export class SkillType {
  public customAttributeMap?: any;
  public customAttributeDefList?: any;
  public customAttribute?: any;
  public skillTypeId: number = 0;
  public skillTypeName: string = '';
  public skillTypeDescription: string = '';
  public locale: string = '';
  public status: string = '';
  public createdDTTM: Date = new Date();
  public updateDTTM: Date = new Date();
  public entityName: string = '';
  public entityId?: any;
  public company?: any;
  public entityCompany?: any;
  public customAttributeObjectKey?: any;
  public customAttributeObjectType?: any;
  public listEntityCode?: any;
  public yearsOfExperience?: any;
  public primary?: any;
}
